module.exports = __webpack_public_path__ + "img/view_module_black.b4b0f4a3.svg";